export const EDUCATOR_TYPES = [
  { value: 1, label: "Clinical Educator" },
  { value: 2, label: "Other (External Training Organisation)" },
  { value: 3, label: "Peer Educator" },
];

export const EDUCATOR_STATUS = [
  { value: 1, label: "Active" },
  { value: 0, label: "Inactive" },
];

export const EDUCATOR_SERVICE = [
  { value: 1, label: "Alcohol and Other Drug Service" },
  { value: 2, label: "District Mental Health Service" },
  { value: 3, label: "Eastern Suburbs Mental Health" },
  { value: 4, label: "General Health Services" },
  { value: 5, label: "Multicultural Health Service" },
  { value: 6, label: "Other" },
  { value: 7, label: "Partner Service" },
  { value: 8, label: "St George Mental Health" },
  { value: 9, label: "Sutherland Mental Health" },
];

export const STUDENT_PROFILE = [];

export const EDUCATOR_FIRST_NAME_MAX_LENGTH = 50;
export const EDUCATOR_LAST_NAME_MAX_LENGTH = 50;
export const EDUCATOR_EMAIL_MAX_LENGTH = 255;
export const EDUCATOR_STREET_ADDRESS_MAX_LENGTH = 255;
export const EDUCATOR_SUBURB_MAX_LENGTH = 100;
export const EDUCATOR_STATE_MAX_LENGTH = 50;
export const EDUCATOR_CITY_MAX_LENGTH = 255;
export const EDUCATOR_PHONE_MAX_LENGTH = 11;
export const EDUCATOR_OTHER_WORKPLACE_MAX_LENGTH = 100;
export const EDUCATOR_AVAILABILITY_MAX_LENGTH = 100;
export const EDUCATOR_EMERGENCY_CONTACT_MAX_LENGTH = 50;
export const EDUCATOR_EMERGENCY_CONTACT_RELATION_MAX_LENGTH = 50;
export const EDUCATOR_SKILLS_MAX_LENGTH = 250;
export const EDUCATOR_COURSE_DELIVERY_LANGUAGE_MAX_LENGTH = 100;
